import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Container, Stack, Typography } from '@mui/material';

const CommunitySubmitSuccess: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm" sx={{ py: { xs: 12, md: 14 } }}>
      <Box sx={{ textAlign: 'center' }}>
        <Typography variant="h3" component="h1" sx={{ fontWeight: 900 }}>
          Success
        </Typography>
        <Typography variant="h6" color="text.secondary" sx={{ mt: 2, fontWeight: 600 }}>
          Profile submitted.
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mt: 1.5 }}>
          An admin will review and publish it soon.
        </Typography>

        <Stack spacing={1.5} sx={{ mt: 4 }}>
          <Button variant="contained" onClick={() => navigate('/community')}>
            Back to Community
          </Button>
          <Button variant="outlined" onClick={() => navigate('/login')}>
            Log in to edit your profile
          </Button>
        </Stack>
      </Box>
    </Container>
  );
};

export default CommunitySubmitSuccess;
